<template>
    <div class="trans">
       <div>
           <h1 class="crff fs28 ac">全网传播指数</h1>
           <div class="search-warp w737">
                <button class="search-btn fr" @click="KeyUpEsc">查询指数</button>
                <div class="hidden">
                    <input type="text" v-model="keywords" @keyup.enter="KeyUpEsc" placeholder="输入人名/地名/公司/机构/事件关键词" class="input-text fl">
                </div>
            </div>
            <div class="hotIndex ac">
                <span class="hotKeyLi cp ovhidden" :class="{'cur':item.isClick}" v-for="(item,index) in hotList.slice(0,16)" :key="index"  @click="goDetail(item.name,index)">{{item.name}}</span>
            </div>
       </div>
	</div>
</template>
<script>
export default {
    components:{
    },
    data() {
        return {
             keywords:'',
             hotList:[],
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.hotList = that.$parent.hotKey;
        })
    },
    watch: {
        '$parent.hotKey':function(){
           this.hotList = this.$parent.hotKey;
        },
    },
    methods: {
        KeyUpEsc(){
            let that = this;
            if(that.keywords==''){
                 that.$utils.alertText('输入人名/地名/公司/机构/事件关键词',300);
                return
            }
            that.$router.push({ path:'/transDetail',query:{keyword:that.keywords}})
        },
        goDetail(value,index){
            let that = this;
            that.$parent.hotKey[index].isClick = true;
            that.$router.push({ path:'/transDetail',query:{keyword:value}})
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/trans/transIndex.vue